var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "footer-navigation footer-software-provider" },
    [
      _c("ul", { staticClass: "footer-list" }, [
        _c(
          "li",
          { staticClass: "footer-list-item" },
          [
            _c("build-version", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.memberevolution.com",
                    target: "_blank",
                    rel: "noopener",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "logo-icon",
                      staticStyle: { "enable-background": "new 0 0 50.1 36.7" },
                      attrs: {
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        x: "0px",
                        y: "0px",
                        viewBox: "0 0 50.1 36.7",
                        "xml:space": "preserve",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M31.9,21.9H17.6c0.4-2.9,2.4-6.4,7.1-6.4C29.8,15.5,31.7,19.1,31.9,21.9z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M47.4,0L28.6,2.2l-3.3,4.5L22,2.2L2.8,0L0,36.6L13.8,35c-2.5-2.6-4.1-6.3-4.1-10.7c0-8.4,6.2-15.2,15-15.2\n            c8.6,0,14.5,6.5,14.5,16v1.7H17.7c0.5,3.7,3.4,6.7,8.3,6.7c2.5,0,5.9-1.1,7.7-2.9l3.3,4.5l13.1,1.6L47.4,0z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("copyright_text", function () {
                    return [
                      _vm._v(
                        "© " +
                          _vm._s(new Date().getFullYear()) +
                          " - Member Evolution"
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }